<template>
  <v-card>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Workplace Settings</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')"><v-icon>close</v-icon></v-btn>
    </v-toolbar>
    <v-tabs vertical>
      <v-tab>
        Profile
      </v-tab>
      <v-tab>
        Plan & Billing
      </v-tab>
      <v-tab>
        Members
      </v-tab>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    autofocus
                    v-model="workspace.name"
                    label="Workspace Name"
                    required
                    @keypress.enter="save"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-alert :value="!!error" type="warning">{{ error }}</v-alert>
          <v-card-actions>
            <v-btn v-if="workspace.name == item.profile.name" text @click="$emit('close')"
              >Done</v-btn
            >
            <template v-else>
              <v-btn color="blue darken-1" text @click="$emit('close')">Cancel</v-btn>
              <v-btn color="primary" @click="save">Save</v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    disabled
                    value="Beta Hero!"
                    label="CurrentPlan"
                    @keypress.enter="create"
                  ></v-text-field>
                </v-flex>
                <v-alert variant="info">
                  You have super special beta access to Context! That means you get all our paid
                  features for flippin' free while we're in beta.
                </v-alert>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions><v-btn text @click="$emit('close')">Done</v-btn></v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <workspace-membership
          v-if="show"
          @done="$emit('close')"
          :workspace="item"
        ></workspace-membership>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import WorkspaceMembership from './WorkspaceMembership';
export default {
  props: ['hover', 'item', 'show'],
  components: { WorkspaceMembership },
  data() {
    return {
      error: false,
      workspace: {
        name: ''
      }
    };
  },
  mounted() {
    this.workspace.name = this.item.profile.name;
  },
  watch: {
    dialog: function(o, n) {
      console.log(this.dialog);
      if (n) {
        this.workspace.name = this.item.profile.name;
      }
    }
  },
  methods: {
    ...mapActions('workspaces', ['updateWorkspaceName']),
    save() {
      if (!this.workspace.name.length) {
        this.error = 'Your workspace needs a name!';
        return;
      }
      this.updateWorkspaceName({ name: this.workspace.name, workspaceId: this.item.id });
      //  close and reset
      this.error = false;
    }
  }
};
</script>
